/* eslint-disable
    @typescript-eslint/no-explicit-any
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  compact: boolean;
  onClick: (...args: Array<any>) => any;
}

export default function SearchButton(props: Props): JSX.Element {
  if (props.compact) {
    return (
      <Tooltip title="Search" placement={TooltipPlacement.BOTTOM}>
        <Button
          aria-label="Search"
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          icon="search"
          onClick={props.onClick}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    );
  }
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_BLUE}
      icon="search"
      onClick={props.onClick}
      size={ButtonSize.SMALL}
      text="Search"
    />
  );
}
SearchButton.defaultProps = {
  compact: true,
};
